module.exports = __webpack_public_path__ + "static/media/exit-page--RGM-Hubble.7e5e21ff.gif";